import type {Stage} from "../src/components/stores/apiService";

type StorybookGlobalSettings = {
	debug: boolean;
	locale: string;
	stage: Stage;
};

export const globalSettings: StorybookGlobalSettings = {
	debug: true,
	locale: "en_US",
	stage: "QA",
};
